import { useQuery, useQueryClient } from "@tanstack/react-query"
import { fetcher } from "../fetcher"
import { useCallback } from "react"

export type TransactionsApiPayment = {
  externalPaymentRequestId: string
  amount: {
    value: number
    currencyCode: string
  }
  recipientName: string
  dueDate: string
  paymentType: string
}

export type TransactionsApiTransaction = {
  externalTransferId: string
  amount: {
    value: number
    currencyCode: string
  }
  recipientName: string
  date: string
  account: string
  isRefunded: boolean
  isReimbursed: boolean
  paymentMethod: "A2A" | "Card"
}

export type TransactionsApiRecipient = {
  recipientProfileId: string
  name: string
  frequency: string
  companyType: "ForProfit" | "NonProfit"
  companyId: string
}

export type TransactionsApiResponse = {
  paymentRequests: TransactionsApiPayment[]
  transactions: TransactionsApiTransaction[]
  recipients: TransactionsApiRecipient[]
}

function getQueryOptions({ newSearchString }: { newSearchString: string }) {
  return {
    queryKey: ["transactionList", { queryString: newSearchString }],
    queryFn: async () => {
      const response = await fetcher(
        `/Transaction/List${newSearchString}`,
        {
          method: "GET",
        },
        {
          useAccessToken: true,
        }
      )

      const responseJson = await response.json()

      return responseJson
    },
  }
}

export function useTransaction(searchParams = new URLSearchParams("")) {
  let newSearchString = searchParams.toString()
  newSearchString = newSearchString ? `?${newSearchString}` : newSearchString

  return useQuery<TransactionsApiResponse>(getQueryOptions({ newSearchString }))
}

export function useFetchTransactions() {
  const queryClient = useQueryClient()

  return useCallback(
    () => queryClient.fetchQuery<TransactionsApiResponse>(getQueryOptions({ newSearchString: "" })),
    [queryClient]
  )
}
